import { isNil } from 'lodash-es';

export function toURLSearchParams(
  params: Record<string, string | number | boolean | undefined | null>,
): URLSearchParams {
  const searchParams = new URLSearchParams();

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const value = params[key];

      if (!isNil(value)) {
        searchParams.append(key, String(value));
      }
    }
  }

  return searchParams;
}
